import { marked } from 'marked'

// Defense in depth for hydrated history / legacy rows — server sends sanitized text.
const XML_LIKE_TAG_PATTERN = /<\/?[a-zA-Z][a-zA-Z0-9_-]*(?:\s[^>]*)?\/?>/g
const FINAL_ANSWER_PATTERN = /<final_answer>([\s\S]*?)<\/final_answer>/i

export function extractFinalAnswer(text) {
  const match = (text || '').match(FINAL_ANSWER_PATTERN)
  return (match ? match[1] : text || '').trim()
}

export function stripXmlLikeTags(text) {
  return (text || '').replace(XML_LIKE_TAG_PATTERN, '')
}

export function prepareBeaconAnswerText(text) {
  return stripXmlLikeTags(extractFinalAnswer(text))
}

export function renderBeaconMarkdown(text) {
  const cleaned = prepareBeaconAnswerText(text)
  try {
    return marked.parse(cleaned, { gfm: true, breaks: true })
  } catch {
    return cleaned.replace(/</g, '&lt;')
  }
}
